class OriginalController {
    constructor(modal, $sce, AppConfig,$state, $stateParams, OrderEmailAPI, message, $scope,$rootScope) {

        "ngInject";

        this.modal = modal;
        this.$sce = $sce;
        this.AppConfig = AppConfig;
        this.$state=$state;
        this.$scope=$scope;
        this.$stateParams = $stateParams;
        this.OrderEmailAPI = OrderEmailAPI;
        this.message = message;
        this.$rootScope=$rootScope

        this.error = false;

        this.showReproductionDetail = false;
        this.reproduction = null;
        this.reproductionPublicKeyHtml = '';

        this.pageQrcodeSrc = '';
        this.isShowAuthorizationTips=false;
        let self=this;
        this.$scope.$on("showTips",function(event,val){
            self.isShowAuthorizationTips=val
        });

        this.showNotify = Boolean($stateParams.notify);
    }

    setReproduction(reproduction) {
        const AppConfig = this.AppConfig
        if (reproduction && reproduction.hasOwnProperty('block_source')) {
            if (reproduction.block_source === 0) {
                reproduction.chain_server_url = `${AppConfig.chain_server_url}/block/${reproduction.block_hash}`
            } else {
                reproduction.chain_server_url = `${AppConfig.newchain_server_url}/original/${reproduction.yuanben_id}`
            }
        }
        this.reproduction = reproduction;

        if (reproduction && reproduction.public_key) {
            this.reproductionPublicKeyHtml = this.$sce.trustAsHtml(reproduction.public_key.replace(/\n/g, "<br/>"));
        }
    }

    setError(error) {
        this.error = error;
    }

    setShowReproductionDetail(show) {
        this.showReproductionDetail = show;
    }

    showReproduction() {
        this.modal.open('reproduction-info');
    }

    shareToWeixin(url) {
        this.pageQrcodeSrc = url;
        this.modal.open('share-to-weixin');
    }

    getAccountType() {
        if (["其他", "网络媒体", "纸质媒体"].indexOf(this.reproduction.reproduction.account_type) !== -1) {
            return this.reproduction.reproduction.type_name;
        }

        return this.reproduction.reproduction.account_type;
    }

    accountNameNeeded(accountType) {
        return ["微信公众号", "微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
    }

    accountIdNeeded(accountType) {
        return ["微信公众号", "其他"].indexOf(accountType) != -1;
    }

    accountLinkNeeded(accountType) {
        return ["微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
    }

    webLinkNeeded(accountType) {
        return ["网络媒体"].indexOf(accountType) != -1;
    }

    editorNameNeeded(accountType) {
        return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
    }

    applyReceipt() {
        this.message.info('请稍后...');
      //   console.log(this.$stateParams.reproduction);

        let params = {
          id: this.$stateParams.reproduction
        };

        this.OrderEmailAPI.one("confirmation").customPOST(params, "").then(
          (login) => {
            let flag = (login === "true");
            this.message.hide();
            if (flag) {
              this.$state.go("app.home.profile.receipt")
            }
            else {
              if (this.reproduction.user.email_verified) {
                this.$state.go('app.face.index.user.form.login');
              }
              else {
                this.modal.open("receipt-apply");

              }
            }
          },
          (resp) => {
            this.message.hide();
            this.$state.go('app.face.index.user.form.login');
          }
        );
    }
}

export default OriginalController;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original.controller.js